import { IMessageType } from '@/services/signalr/types';
import { IStatusMsg } from '~/api/messages/IStatusMsg';
import { IUnitListReqMsg } from '~/api/messages/IUnitListReqMsg';
import { IUnitMsg } from '~/api/messages/IUnitMsg';
import { IUnitUpdateReqMsg } from '~/api/messages/IUnitUpdateReqMsg';
import { IUnitsMsg } from '~/api/messages/IUnitsMsg';

export const UnitMsg: IMessageType<IUnitMsg, IStatusMsg> = {
  requestName: 'UnitMsg',
  responseName: 'StatusMsg',
};

export const UnitListReqMsg: IMessageType<IUnitListReqMsg, IUnitsMsg> = {
  requestName: 'UnitListReqMsg',
  responseName: 'UnitsMsg',
};

export const UpdateUnit: IMessageType<IUnitMsg, IStatusMsg> = {
  requestName: 'UpdateUnit',
  responseName: 'StatusMsg',
  processMessage: false,
};

/** Hybrid will not support this message */
export const UnitUpdateReqMsg: IMessageType<IUnitUpdateReqMsg, IStatusMsg> = {
  requestName: 'UnitUpdateReqMsg',
  responseName: 'StatusMsg',
};
